<template>
    <div>
        <!--SELECT : Dropdown select field.-->
        <label class="control-label">{{ pieceName }}</label>
        <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>

        <select :name="'pieces[' + pieceIndex + '][content]'" :class="'select form-control ' + pieceName" data-field-type="select">
            <option></option>
            <option v-for="(option,index) in (pieceOptions && pieceOptions['options']).split(',')" :key="index"  :value="option" :selected="option === escapeHtml(stripSlashes(pieceContent))" >{{ stripSlashes(option) }}</option>
        </select>
        <div class="step-spacer"></div>
    </div>
</template>

<script>

    import utils from '../../../../mixins/utils';

    export default {
        name: 'select-piece',
        data() {
            return {
            };
        },
        mixins: [utils],
        props: {
            pieceIndex: {
                type: Number,
                required:true
            },
            pieceName: {
                type: String,
                required:true
            },
            pieceContent: {
                type: String,
                required:true
            },
            pieceOptions: {
                type: Object,
                required:true
            },
            pieceData: {
                type: Object,
                required:true
            },
        }
    }
</script>

<style lang="scss">

</style>
